<template>
  <div :class="{
         'ca-label-dato--bold': dato_bold,
         'ca-label-dato--dark': dark,
         'ca-label-dato--inverted': inverted
       }"
       :style="{ width: ancho ? ancho + 'px' : 'fit-content' }"
       class="ca-label-dato"
  >
    <div class="label">{{ label }}</div>
    <div class="dato" v-if="dato">
      <span ref="dato">{{ dato }}</span>
      <v-icon @click="copiarDato()" title="Copiar" v-if="copiable">file_copy</v-icon>
    </div>
    <slot v-else></slot>
  </div>
</template>
<script>
export default {
  /**
     * Componente base CaLabelDato
     *
     * Visualización desparramada por toda la plataforma de un dato con un label que lo describe (generalmente en la
     *  parte superior aunque se puede invertir con prop inverted).
     * Generalmente se utiliza con props label y dato que son strings, si se requiere mostrar algo más complejo que un string
     *  se deja el prop dato vacío y en cambio se utiliza el slot default (caso de ejemplo component BoxMorosidad en
     *  views/contable/expensas-vecinos/components)
     *
     * Props de estilización: dato_bold, ancho, dark, inverted.
     */
  props: {
    label: {type: String, default: ''},
    dato: {type: String, default: ''},
    dato_bold: {type: Boolean, default: false}, // Estilización condicional
    ancho: {type: Number, default: 0}, // Width del elemento, por defecto se ajusta al contenido
    dark: {type: Boolean, default: false}, // Estilización condicional (colores de fuente claros)
    copiable: {type: Boolean, default: false}, // Puede copiarse al portapapeles el string que haya en dato
    inverted: {type: Boolean, default: false} // Se invierten las posiciones de label y dato (dato arriba y label abajo)
  },
  methods: {
    copiarDato() {
      this.selectText(this.$refs.dato);
      document.execCommand('copy');
    },
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      }
      else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    }
  }
};
</script>
<style lang="scss">
  .ca-label-dato {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.1;
    margin-right: 20px;

    .label {
      font-size: 12px;
      white-space: nowrap;
      overflow: visible;
      color: color(gris);
    }

    .dato {
      font-size: 15px;
      line-height: 1.4;
      color: color(dark);
      white-space: nowrap;
      overflow: visible;
    }

    // Modificadores
    &.ca-label-dato--bold {
      .dato {
        font-weight: bold;
      }
    }

    &.ca-label-dato--dark {
      .label {
        color: color(celeste-claro);
      }

      .dato {
        color: color(blanco);
      }

      .v-icon:hover {
        color: color(celeste-agua);
      }
    }

    &.ca-label-dato--inverted {
      flex-direction: column-reverse;
    }
  }
</style>
